import React, { useState, useEffect } from 'react';

export const THEMES = [
  { value: 'clair', label: 'Clair', emoji: '☀️', preview: ['#ffffff', '#6366f1', '#1e293b'] },
  { value: 'sombre', label: 'Sombre', emoji: '🌙', preview: ['#0f172a', '#818cf8', '#f1f5f9'] },
  { value: 'pastel', label: 'Pastel', emoji: '🌸', preview: ['#fefaf6', '#c084fc', '#fce7f3'] },
  { value: 'ocean', label: 'Océan', emoji: '🌊', preview: ['#f0f9ff', '#0ea5e9', '#0c4a6e'] },
  { value: 'sepia', label: 'Sépia', emoji: '📜', preview: ['#fdf6e3', '#b45309', '#44403c'] },
  { value: 'zen', label: 'Zen', emoji: '🧘', preview: ['#faf8f3', '#87a878', '#a89d8a'] },
  { value: 'japon', label: 'Japon', emoji: '🎌', preview: ['#faf5ed', '#cb3040', '#1a1917'] },
];

export function applyTheme(theme) {
  // Retire toutes les classes theme-*
  THEMES.forEach(t => document.body.classList.remove('theme-' + t.value));
  // Ajoute la nouvelle
  document.body.classList.add('theme-' + theme);
  localStorage.setItem('theme', theme);
}

export function useTheme() {
  const [theme, setTheme] = useState(() => localStorage.getItem('theme') || 'clair');

  useEffect(() => { applyTheme(theme); }, [theme]);

  return [theme, setTheme];
}

export default function ThemeSwitcher({ compact = false }) {
  const [theme, setTheme] = useTheme();

  if (compact) {
    // Version compacte : juste une série de petits ronds
    return (
      <div style={{ display: 'flex', gap: 6, padding: '8px 10px', flexWrap: 'wrap' }}>
        {THEMES.map(t => (
          <button
            key={t.value}
            onClick={() => setTheme(t.value)}
            title={t.label}
            style={{
              width: 28, height: 28, borderRadius: '50%',
              background: `linear-gradient(135deg, ${t.preview[0]} 0%, ${t.preview[0]} 50%, ${t.preview[1]} 50%, ${t.preview[1]} 100%)`,
              border: theme === t.value ? '2px solid white' : '2px solid transparent',
              boxShadow: theme === t.value ? '0 0 0 2px var(--primary)' : '0 0 0 1px rgba(255,255,255,0.2)',
              cursor: 'pointer',
              padding: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '0.75rem',
              transition: 'all 0.2s',
            }}
          >
            {theme === t.value && <span style={{ fontSize: '0.9rem' }}>{t.emoji}</span>}
          </button>
        ))}
      </div>
    );
  }

  // Version complète avec libellés
  return (
    <div style={{ padding: '10px' }}>
      <div style={{ fontSize: '0.7rem', fontWeight: 700, color: 'rgba(255,255,255,0.35)', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 8, padding: '0 4px' }}>
        🎨 Thème
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
        {THEMES.map(t => (
          <button
            key={t.value}
            onClick={() => setTheme(t.value)}
            title={t.label}
            style={{
              flex: '1 1 auto',
              minWidth: 40,
              padding: '8px 6px',
              borderRadius: 8,
              border: theme === t.value ? '2px solid var(--primary-light)' : '2px solid transparent',
              background: theme === t.value ? 'rgba(255,255,255,0.1)' : 'transparent',
              color: 'var(--text-sidebar)',
              fontSize: '0.7rem',
              fontWeight: 600,
              cursor: 'pointer',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 2,
              transition: 'all 0.2s',
            }}
          >
            <span style={{ fontSize: '1rem' }}>{t.emoji}</span>
            <span>{t.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
